// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GxVy","colBig":"styles_colBig__3xjcG","colSmall":"styles_colSmall__3LF2L"};